<script>
import FundraiserPageCompact from '@/components/fundraiser-pages/public/fundraiser-page-compact.vue'

import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
export default {
  name: "FundraiserPagesFrontendList",
  components: { TwButton, TwInput, TwLoadingSpinner, FundraiserPageCompact, MagnifyingGlassIcon, XMarkIcon },
  mixins:[fetchDataMixin],
  props: {
    fundraiser: {
      type: Object,
      required:true
    },
    team: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      FilterByName: null,
    }
  },
  computed: {
    fundraiserPages() {
      return useFundraiserPagePublicStore(this.$options.name).getItemsByFundraiserId(this.fundraiser.id)
    },
    total() {
      return useFundraiserPagePublicStore(this.$options.name).total
    }
  },
  watch: {
    Page() {
      this.fetchFundraiserPages()
    },
    team() {
      this.$nextTick(() => {
        this.fetchFundraiserPages()
      })
    }
  },
  onUnmounted() {
    useFundraiserPagePublicStore(this.$options.name).clearItems()
  },
  mounted() {
    this.fetchFundraiserPages()
  },
  methods: {
    clearFilters() {
      this.FilterByName = null
      this.fetchFundraiserPages()
    },
    async fetchFundraiserPages() {
      await this.fetchData(async () => {
        await useFundraiserPagePublicStore(this.$options.name).fetchItems({
          clear: true,
          fundraiser_id: this.fundraiser.id,
          page: this.Page,
          ...(this.team ? { team_id: this.team.id } : {}),
          ...(this.FilterByName ? { name: this.FilterByName  } : {})
        })
      })
    }
  }
}
</script>

<template>
  <div class="mb-10">
      <!-- <div class="text-xl">
        <span v-if="total" class="font-bold">{{ total }} people</span><span v-else> No </span> are fundraising for <span v-if="team"> team <span class="font-semibold"> {{ team.name }}</span> </span><span v-else> this cause</span>
        <span v-if="FilterByName"> with name containing <span class="font-semibold">"{{ FilterByName }}"</span></span>
      </div> -->
      <div class="relative">
        <tw-input  v-model="FilterByName" placeholder="Search & hit enter" @keydown.enter="fetchFundraiserPages" />
        <!-- <MagnifyingGlassIcon class="size-5 text-gray-600 absolute top-3.5 left-3" aria-hidden="true" /> -->
        <tw-button class="absolute py-1 px-2 right-2 top-2 btn-pill text-gray-600 text-xs" size="small" variant="light" @click="clearFilters">
          Clear
          <XMarkIcon class="h-4 w-4" />
        </tw-button>
      </div>
      <!-- <div class="flex flex-row gap-4">
        <tw-input v-model="FilterByName" placeholder="Search for fundraiser member and hit Enter" @keydown.enter="fetchFundraiserPages" />
      </div> -->
    </div>
    <div class="grid sm:grid-cols-2 gap-10 lg:gap-12">
      <tw-loading-spinner v-if="Loading" />
      <template v-else>
        <fundraiser-page-compact v-for="fundraiserPage in fundraiserPages" :key="'fundraiser-page-compact-list-' + fundraiserPage.id + '-' + fundraiserPage.fundraiser_id" :fundraiser-page="fundraiserPage" />
      </template>
    </div>
</template>

<style scoped>

</style>
